import React from "react";
import { Translation, t } from "../../../core/translate";
import SharedLinks from "../shared-links";
import { connect } from "react-redux";
import { selectors as brandSelectors } from "../../../../redux/brand";
import { selectors as routerSelectors } from "../../../../redux/router";
import {
  actions as userActions,
  selectors as userSelectors
} from "../../../../redux/user";
import ContainerLayout from "../container-layout";
import ForgotForm from "./forgot-form";
import PasswordResetForm from "./password-reset-form";
import Spinner from "../../../components/spinner";
import Link from "../../../components/link";
import { GrayBlock } from "../styles";
import { FormAlert } from "../form-alert";

class Forgot extends React.Component {
  state = {};

  getTitle() {
    if (this.props.expired) {
      return (
        <Translation id="forgot-password.forgot-password-expired-heading">
          Password Reset Link Expired
        </Translation>
      );
    } else {
      return (
        <Translation id="forgot-password.forgot-password-heading">
          Enter your email and we’ll send you a link to reset your password.
        </Translation>
      );
    }
  }

  resetPassword = e => {
    e.preventDefault();
    const { resetPassword, resetUrl } = this.props;
    resetPassword(e.target.elements["email"].value, resetUrl).then(() => {
      this.setState({ passwordReset: true });
    });
    return;
  };

  updateForgottenPassword = e => {
    e.preventDefault();
    const { updateForgottenPassword, resetToken } = this.props;
    this.setState({
      updatingPassword: true,
      error: false
    });
    updateForgottenPassword(
      resetToken,
      e.target.elements["password"].value
    ).then(({ success, error }) => {
      if (success) {
        this.setState({ passwordUpdated: true, updatingPassword: false });
      } else if (error.errors) {
        switch (error.errors.message) {
          case "Invalid or expired password reset token":
            this.setState({ error: "linkExpired", updatingPassword: false });
            break;
          case "Password can not be the same as the previous password":
            this.setState({ error: "samePassword", updatingPassword: false });
            break;
          default:
            this.setState({ error: "unknown", updatingPassword: false });
            break;
        }
      }
    });
  };

  linkExpired() {
    return (
      <div>
        <FormAlert level="error" key="token-expired">
          <Translation id="forgot-password.forgot-password-expired-heading">
            Password Link Expired
          </Translation>
        </FormAlert>
        <GrayBlock>
          <p>
            <Translation id="forgot-password.link-expired-text">
              Your reset token has expired.
            </Translation>
          </p>
          <Link href="/user/forgot">
            <Translation id="forgot-password.reset-button">Reset</Translation>
          </Link>
        </GrayBlock>
      </div>
    );
  }

  unknownError() {
    return (
      <div>
        <FormAlert level="error" key="token-expired">
          <Translation id="forgot-password.forgot-password-expired-heading">
            Password Link Expired
          </Translation>
        </FormAlert>
        <GrayBlock>
          <p>
            <Translation id="forgot-password.link-expired-text">
              Your reset token has expired.
            </Translation>
          </p>
          <Link href="/user/forgot">
            <Translation id="forgot-password.reset-button">Reset</Translation>
          </Link>
        </GrayBlock>
      </div>
    );
  }

  renderForgotForms() {
    const { resetToken, forgotEnabled } = this.props;
    const { error } = this.state;
    if (resetToken && error === "linkExpired") {
      return this.linkExpired();
    } else if (resetToken && error === "unknown") {
      return (
        <FormAlert level="error" key="unknown-error">
          <Translation id="messages.500-error">
            Something went wrong. Please try again later.
          </Translation>
        </FormAlert>
      );
    } else if (resetToken) {
      return (
        <div>
          {error === "samePassword" && (
            <FormAlert level="error" key="same-password">
              <Translation id="update-password.cannot-be-the-same">
                Password can not be the same as the previous password
              </Translation>
            </FormAlert>
          )}
          <PasswordResetForm
            updateForgottenPassword={this.updateForgottenPassword}
            passwordUpdated={this.state.passwordUpdated}
          />
        </div>
      );
    } else if (forgotEnabled) {
      return (
        <ForgotForm
          resetPassword={this.resetPassword}
          passwordReset={this.state.passwordReset}
        />
      );
    }
    return null;
  }

  render() {
    return (
      <ContainerLayout
        graphic="forgot"
        pageTitle={t("signin.forgot-password", "Forgot Password")}
        title={this.getTitle()}
      >
        {this.renderForgotForms()}
        {this.props.isResettingPassword ||
          (this.state.updatingPassword && <Spinner />)}
        <SharedLinks signIn />
      </ContainerLayout>
    );
  }
}

const mapStateToProps = state => ({
  forgotEnabled: brandSelectors.getBrandValue(
    state,
    "ForgotPassword.enabled",
    true
  ),
  resetToken: routerSelectors.getQueryParam(state, "token"),
  resetUrl: `${routerSelectors.getRootRoute(state)}/#/user/forgot`,
  isResettingPassword: userSelectors.isResettingPassword(state)
});

const mapDispatchToProps = dispatch => ({
  resetPassword: (email, url) =>
    dispatch(userActions.resetPassword(email, url)),
  updateForgottenPassword: (resetToken, password) =>
    dispatch(userActions.updateForgottenPassword(resetToken, password))
});

const ConnectedForgot = connect(mapStateToProps, mapDispatchToProps)(Forgot);

export default ConnectedForgot;
